<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="integrity-page integrity-dashboard">
  <header class="dashboard-header">
    <div class="header-top">
      <div class="header-title">
        <h1>Integridades</h1>
        <p>Monitoramento e correção das rotinas operacionais.</p>
      </div>
      <div class="header-buttons">
        <div class="header-collapse">
          <button
            pButton
            type="button"
            class="p-button-text header-pill-btn header-pill-btn--icon"
            pTooltip="Expandir todas as categorias"
            tooltipPosition="bottom"
            (click)="setExpandedForAll(true, $event)"
          >
            <span
              class="header-pill-btn__icon pi pi-chevron-down"
              aria-hidden="true"
            ></span>
            <span class="header-pill-btn__label">Expandir</span>
          </button>
          <button
            pButton
            type="button"
            class="p-button-text header-pill-btn header-pill-btn--icon"
            pTooltip="Recolher todas as categorias"
            tooltipPosition="bottom"
            (click)="setExpandedForAll(false, $event)"
          >
            <span
              class="header-pill-btn__icon pi pi-chevron-up"
              aria-hidden="true"
            ></span>
            <span class="header-pill-btn__label">Recolher</span>
          </button>
        </div>
        <button
          pButton
          type="button"
          class="header-pill-btn header-pill-btn--primary-success"
          (click)="selectedIntegrityId = null; showIntegrityDialog = true"
        >
          <span
            class="header-pill-btn__icon pi pi-plus"
            aria-hidden="true"
          ></span>
          <span class="header-pill-btn__label">Nova Integridade</span>
        </button>
        <button
          pButton
          type="button"
          class="header-pill-btn header-pill-btn--primary-info"
          (click)="selectedCategoryId = null; showCategoryDialog = true"
        >
          <span
            class="header-pill-btn__icon pi pi-folder-plus"
            aria-hidden="true"
          ></span>
          <span class="header-pill-btn__label">Nova Categoria</span>
        </button>
      </div>
    </div>

    <div class="metrics-row">
      <div class="metric-card primary">
        <div class="metric-icon-wrapper">
          <i class="pi pi-list"></i>
        </div>
        <div class="metric-content">
          <span class="metric-label">Total</span>
          <span class="metric-value">{{ totalIntegrities }}</span>
        </div>
      </div>
      <div class="metric-card warning">
        <div class="metric-icon-wrapper">
          <i class="pi pi-exclamation-triangle"></i>
        </div>
        <div class="metric-content">
          <span class="metric-label">Com problemas</span>
          <span class="metric-value">{{ totalWithIssues }}</span>
        </div>
      </div>
      <div class="metric-card success">
        <div class="metric-icon-wrapper">
          <i class="pi pi-check-circle"></i>
        </div>
        <div class="metric-content">
          <span class="metric-label">Sem problemas</span>
          <span class="metric-value">{{ totalWithoutIssues }}</span>
        </div>
      </div>
    </div>

    <div class="filters-row">
      <p-dropdown
        [options]="categoryOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="categoryFilter"
        (onChange)="applyFilters()"
        placeholder="Categoria"
      ></p-dropdown>

      <p-dropdown
        [options]="resolutionOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="resolutionFilter"
        (onChange)="applyFilters()"
        placeholder="Tipo de resolução"
      ></p-dropdown>

      <p-dropdown
        [options]="statusOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="statusFilter"
        (onChange)="applyFilters()"
        placeholder="Status"
      ></p-dropdown>

      <button
        pButton
        type="button"
        class="header-pill-btn header-pill-btn--ghost reset-btn"
        (click)="resetFilters()"
      >
        <span
          class="header-pill-btn__icon pi pi-filter-slash"
          aria-hidden="true"
        ></span>
        <span class="header-pill-btn__label">Limpar filtros</span>
      </button>
    </div>
  </header>

  <main class="integrity-content">
    <p-message
      *ngIf="!visibleCategories.length"
      severity="info"
      text="Nenhuma integridade encontrada com os filtros atuais."
    ></p-message>

    <div
      class="category-drop-list"
      cdkDropList
      [cdkDropListData]="visibleCategories"
      (cdkDropListDropped)="drop($event)"
    >
      <section
        class="category-panel"
        *ngFor="let category of visibleCategories; trackBy: trackByCategory"
        cdkDrag
        [class.collapsed]="
          !isCategoryExpanded($any(category).integrityCategoryId)
        "
      >
        <div
          class="category-panel__header"
          (click)="toggleCategory($any(category).integrityCategoryId)"
          role="button"
          tabindex="0"
          (keydown.enter)="toggleCategory($any(category).integrityCategoryId)"
          (keydown.space)="
            toggleCategory($any(category).integrityCategoryId);
            $event.preventDefault()
          "
          [attr.aria-expanded]="
            isCategoryExpanded($any(category).integrityCategoryId)
          "
        >
          <i
            class="pi pi-bars"
            cdkDragHandle
            (click)="$event.stopPropagation()"
          ></i>
          <button
            type="button"
            class="category-panel__toggle"
            (click)="
              toggleCategory($any(category).integrityCategoryId);
              $event.stopPropagation()
            "
          >
            <i
              class="pi"
              [ngClass]="{
                'pi-chevron-down': isCategoryExpanded(
                  $any(category).integrityCategoryId
                ),
                'pi-chevron-right': !isCategoryExpanded(
                  $any(category).integrityCategoryId
                )
              }"
            ></i>
          </button>

          <div class="category-panel__meta">
            <h2>{{ category.integrityCategoryName }}</h2>
            <span>
              {{ category.integritysFiltered.length }} integridade(s) ·
              {{ category.issuesCount }} com problemas
            </span>
          </div>

          <div class="category-panel__actions integrity-card__actions">
            <button
              pButton
              type="button"
              icon="pi pi-refresh"
              class="p-button-rounded p-button-text p-button-icon-only p-button-info"
              [loading]="
                isCategoryRefreshing($any(category).integrityCategoryId)
              "
              [disabled]="
                isCategoryRefreshing($any(category).integrityCategoryId) ||
                isCategoryBusy($any(category).integrityCategoryId)
              "
              (click)="
                refreshCategory(category, $event); $event.stopPropagation()
              "
              pTooltip="Atualizar integridades desta categoria"
              aria-label="Atualizar categoria"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text p-button-icon-only p-button-secondary"
              [disabled]="isCategoryBusy($any(category).integrityCategoryId)"
              (click)="editCategory(category, $event); $event.stopPropagation()"
              pTooltip="Editar categoria"
              aria-label="Editar categoria"
            ></button>

            <button
              pButton
              type="button"
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-icon-only p-button-danger"
              [disabled]="isCategoryBusy($any(category).integrityCategoryId)"
              (click)="
                deleteCategory(category, $event); $event.stopPropagation()
              "
              pTooltip="Excluir categoria"
              aria-label="Excluir categoria"
            ></button>
          </div>
        </div>

        <!-- Custom Drag Preview -->
        <div *cdkDragPreview [matchSize]="true" class="custom-drag-preview">
          <!-- Wrapper to apply scoped variables/styles without page layout -->
          <div class="integrity-page preview-scope">
            <div class="category-panel__header">
              <i class="pi pi-bars"></i>
              <button type="button" class="category-panel__toggle">
                <i class="pi pi-chevron-right"></i>
              </button>
              <div class="category-panel__meta">
                <h2>{{ category.integrityCategoryName }}</h2>
                <span>
                  {{ category.integritysFiltered.length }} integridade(s) ·
                  {{ category.issuesCount }} com problemas
                </span>
              </div>

              <!-- Visual-only action buttons to match appearance -->
              <div class="category-panel__actions integrity-card__actions">
                <button
                  pButton
                  type="button"
                  icon="pi pi-refresh"
                  class="p-button-rounded p-button-text p-button-icon-only p-button-info"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text p-button-icon-only p-button-secondary"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-text p-button-icon-only p-button-danger"
                ></button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="category-panel__body"
          *ngIf="isCategoryExpanded($any(category).integrityCategoryId)"
        >
          <ng-container
            *ngIf="category.integritysFiltered.length; else emptyCategory"
          >
            <div class="table-view">
              <div class="table-toolbar">
                <button
                  pButton
                  type="button"
                  label="Atualizar selecionados"
                  icon="pi pi-refresh"
                  class="p-button-sm"
                  [disabled]="
                    !hasTableSelection($any(category).integrityCategoryId) ||
                    isCategoryRefreshing($any(category).integrityCategoryId)
                  "
                  (click)="refreshSelectedIntegrities(category, $event)"
                ></button>
                <button
                  pButton
                  type="button"
                  label="Exportar CSV"
                  icon="pi pi-download"
                  class="p-button-sm p-button-text"
                  [disabled]="!category.integritysFiltered.length"
                  (click)="exportCategory(category, $event)"
                ></button>
              </div>

              <div
                cdkDropList
                [cdkDropListData]="category.integritysFiltered"
                (cdkDropListDropped)="dropIntegrity($event, category)"
                [cdkDropListAutoScrollDisabled]="false"
              >
                <p-table
                  [value]="category.integritysFiltered"
                  dataKey="integrityId"
                  responsiveLayout="scroll"
                  [(selection)]="
                    tableSelections[$any(category).integrityCategoryId]
                  "
                  [loading]="
                    isCategoryRefreshing($any(category).integrityCategoryId)
                  "
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                      </th>
                      <th style="width: 2rem"></th>
                      <th>Nome</th>
                      <th>Tipo</th>
                      <th>Tratativa</th>
                      <th>Views</th>
                      <th>Status</th>
                      <th>Atualizada</th>
                      <th>Duração</th>
                      <th class="text-right">Ações</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr
                      cdkDrag
                      class="integrity-table__row"
                      tabindex="0"
                      (click)="onTableRowNavigate(row, $event)"
                      (keydown.enter)="onTableRowNavigate(row, $event)"
                      (keydown.space)="onTableRowNavigate(row, $event)"
                      [attr.aria-label]="
                        'Abrir integridade ' + (row?.integrityName || '')
                      "
                    >
                      <td>
                        <p-tableCheckbox [value]="row"></p-tableCheckbox>
                      </td>
                      <td>
                        <i
                          class="pi pi-bars integrity-drag-handle"
                          cdkDragHandle
                          (click)="$event.stopPropagation()"
                        ></i>
                      </td>
                      <td>{{ row.integrityName }}</td>
                      <td>
                        <span class="chip">
                          {{ formatResolutionType($any(row).resolutionType) }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="chip"
                          [ngClass]="
                            $any(row).automaticUpdate
                              ? 'chip--auto'
                              : 'chip--manual'
                          "
                        >
                          {{
                            $any(row).automaticUpdate ? 'Automática' : 'Manual'
                          }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="chip"
                          [ngClass]="
                            $any(row).enableToViews
                              ? 'chip--auto'
                              : 'chip--manual'
                          "
                        >
                          {{ $any(row).enableToViews ? 'Visível' : 'Oculta' }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="chip"
                          [ngClass]="
                            row.integrityCounter > 0
                              ? 'chip--status-issue'
                              : 'chip--status-ok'
                          "
                        >
                          {{
                            row.integrityCounter > 0
                              ? row.integrityCounter + ' pendência(s)'
                              : 'Sem problemas'
                          }}
                        </span>
                      </td>
                      <td>{{ formatRelativeTime($any(row).lastRunAt) }}</td>
                      <td>{{ formatDuration($any(row).durationMs) }}</td>
                      <td class="text-right table-actions">
                        <div class="table-actions__content">
                          <button
                            pButton
                            type="button"
                            icon="pi pi-play"
                            class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-success"
                            [disabled]="
                              isBusy(row.integrityId) ||
                              (row.integrityCounter === 0 && row.resolutionType !== 'JAVA_HANDLER_STANDALONE')
                            "
                            (click)="resolve(row.integrityId, $event)"
                            pTooltip="Resolver problemas"
                            aria-label="Resolver"
                          ></button>
                          <button
                            *ngIf="row.resolutionType !== 'JAVA_HANDLER_STANDALONE'"
                            pButton
                            type="button"
                            icon="pi pi-refresh"
                            class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-info"
                            [disabled]="isBusy(row.integrityId)"
                            (click)="refresh(row.integrityId, $event)"
                            pTooltip="Atualizar contador"
                            aria-label="Atualizar"
                          ></button>
                          <button
                            pButton
                            type="button"
                            icon="pi pi-pencil"
                            class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-secondary"
                            [disabled]="isBusy(row.integrityId)"
                            (click)="edit(row.integrityId, $event)"
                            pTooltip="Editar integridade"
                            aria-label="Editar"
                          ></button>
                          <button
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-text p-button-icon-only p-button-sm p-button-danger"
                            [disabled]="isBusy(row.integrityId)"
                            (click)="delete(row.integrityId, $event)"
                            pTooltip="Excluir integridade"
                            aria-label="Excluir"
                          ></button>
                        </div>
                      </td>

                      <!-- Custom Drag Preview for Integrity Row -->
                      <div
                        *cdkDragPreview
                        [matchSize]="true"
                        class="integrity-row-preview"
                      >
                        <div class="integrity-page preview-scope">
                          <div class="preview-row">
                            <i class="pi pi-bars"></i>
                            <span class="preview-name">{{
                              row.integrityName
                            }}</span>
                            <span
                              class="chip"
                              [ngClass]="
                                row.integrityCounter > 0
                                  ? 'chip--status-issue'
                                  : 'chip--status-ok'
                              "
                            >
                              {{
                                row.integrityCounter > 0
                                  ? row.integrityCounter + ' pendência(s)'
                                  : 'Sem problemas'
                              }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-container>

          <ng-template #emptyCategory>
            <div class="empty-category">
              <p-message
                severity="info"
                text="Nenhuma integridade atende aos filtros nesta categoria."
              ></p-message>
            </div>
          </ng-template>
        </div>
      </section>
    </div>
  </main>
</div>

<p-dialog
  [header]="
    selectedIntegrityId ? 'Editar Integridade' : 'Cadastrar Integridade'
  "
  [(visible)]="showIntegrityDialog"
  [modal]="true"
  [style]="{ width: '900px', maxWidth: '95vw' }"
  (onHide)="onDialogHide()"
  [draggable]="false"
>
  <app-integrity-form
    *ngIf="showIntegrityDialog"
    [integrityId]="selectedIntegrityId"
    (saved)="onIntegritySaved()"
  ></app-integrity-form>
</p-dialog>

<p-dialog
  [header]="
    selectedCategoryId
      ? 'Editar Categoria de Integridade'
      : 'Nova Categoria de Integridade'
  "
  [(visible)]="showCategoryDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  (onHide)="onDialogHide()"
>
  <app-integrity-category-form
    *ngIf="showCategoryDialog"
    [categoryId]="selectedCategoryId"
    (saved)="onCategorySaved()"
  ></app-integrity-category-form>
</p-dialog>
